<template>
  <hic-list-page title="治疗项目维护" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="请输入名称或编码">
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small">
        <i class="el-icon-plus"></i>
        新建
      </el-button>
    </template>

    <el-table-column label="操作" width="150" align="center">
      <template slot-scope="scope">
        <el-button type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" />
        <hic-regret-button type="danger" icon="el-icon-delete" circle plain @click="del(scope.row, scope.$index)" :seconds="5" size="mini" badge="success" :disabled="!scope.row.id" class="left-pad"></hic-regret-button>
        <el-tag v-if="!scope.row.id" size="mini" type="info">已删除</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="执行科室" prop="execDeptCode" width="150" align="center" :filter-multiple="false" column-key="execDeptCode" :filters="dict.Dept">
      <template slot-scope="{ row }">
        {{ row.execDeptCode | dictText('Dept') }}
      </template>
    </el-table-column>

    <el-table-column label="项目编码" prop="code" min-width="150" align="center">
      <template slot-scope="{ row }">
        {{ row.standardCode }}
      </template>
    </el-table-column>

    <el-table-column label="名称" prop="name" min-width="100">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>

    <el-table-column label="单价" prop="price" min-width="100">
      <template slot-scope="{ row }">
        <b>{{ row.price }}</b>
      </template>
    </el-table-column>

    <el-table-column label="备注" prop="memo" min-width="200" align="center" :filter-multiple="false">
      <template slot-scope="{ row }">
        {{ row.memo }}
      </template>
    </el-table-column>

    <examineItem-edit v-if="showEditor" :visible.sync="showEditor" :examineItem="entity" @ok="ok" />
  </hic-list-page>
</template>

<script>
import api from './api.js';
import store from '@/common/store';
import { mapGetters } from 'sw-hic';
export default {
  components: {
    'examineItem-edit': () => import('./edit'),
  },
  data() {
    return {
      showEditor: false,
      showRoles: false,
      entities: {},
      entity: {},
      condition: {
        keyword: null,
        deptCode: null,
        pageIndexOnView: 1,
        pageSize: 20,
      },
      meta:{
        loading: false,
      },
      editingIndex: -1,
    };
  },
  computed: {
    ...mapGetters(['dict', 'permission', 'dictEnum']),
  },
  created: function () {
    this.$store.dispatch('loadDicts', ['Dept', 'Gender', 'ExamineItemType', 'DoctorPosition', 'SpecimenType', 'ExamineType', 'AppType']);
  },
  methods: {
    rowClick(row) {
      if (this.isSwitch) {
        this.$set(row, 'isProduce', !row.isProduce);
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.isSwitch) {
        if (row.isProduce) {
          return 'active-row';
        }
        return 'shover-row';
      }
    },
    page: function () {
      let _this = this;
      this.meta.loading = true;
      api
        .TherapyItem.query(this.condition)
        .then(res => {
          _this.entities = res;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          _this.meta.loading = false;
        });
    },
    create: function () {
      this.editingIndex = 0;
      this.entity = {
        id: null,
        joinDate: new Date(),
        price: '',
      };
      this.showEditor = true;
    },
    edit(row, index) {
      this.entity = JSON.parse(JSON.stringify(row));
      this.showEditor = true;
    },
    ok(newEntity) {
      this.page();
    },
    del: function (row, index) {
      let _this = this;
      api.TherapyItem.del(row.id).then(res => {
        _this.entities.items.splice(index, 1, {});
        _this.$message.success('删除成功！');
      });
    },
    bingRole(row) {
      this.entity = row;
      this.showRoles = true;
    },
    filterChanged(options) {
      options[Object.keys(options)[0]] = Object.values(options)[0][0];
      Object.assign(this.condition, options);
      this.page();
    },
  },
};
</script>

<style scoped>
.el-table /deep/ .active-row {
  background: #f5f7fa;
  cursor: pointer;
  color: #66b1ff;
}
.el-table /deep/ .shover-row {
  cursor: pointer;
}
</style>
